export const PROFILE_FINANCIAL_DETAILS_INHABITANT_DATA = {
  bank_name:
    'Erste Bank und Sparkasse AG, Vienna Main Branch (Filiale Wien Innere Stadt), IBAN: AT61 1904 3002 3457 3201',
  bic: 'GIBAATWWXXX',
  deposit: { amount: '1000000.00', currency: 'EUR' },
  iban: 'AT483200000012345864',
  notes:
    'All financial transactions related to this account must strictly comply with agreed contractual terms and applicable banking regulations.',
  open_amount: { amount: '2000000.00', currency: 'EUR' },
  payment_type:
    'Primary payment method is SEPA bank transfer (Überweisung) in EUR, processed within standard European banking (1–2 business days).',
}
